webpackJsonp([1],{

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(80)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(83),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(81)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(84),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(82)

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(85),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_sweetalert__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MeiParaMe__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MeiParaMe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_MeiParaMe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContabilidadeOnline__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContabilidadeOnline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ContabilidadeOnline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AbrirEmpresa__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AbrirEmpresa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_AbrirEmpresa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_pt_br__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_pt_br__);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_pt_br___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_sweetalert___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  components: {
    MeiParaMe: __WEBPACK_IMPORTED_MODULE_4__components_MeiParaMe___default.a,
    ContabilidadeOnline: __WEBPACK_IMPORTED_MODULE_5__components_ContabilidadeOnline___default.a,
    AbrirEmpresa: __WEBPACK_IMPORTED_MODULE_6__components_AbrirEmpresa___default.a
  }
});

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_awesome_mask__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha___default.a
  },

  directives: {
    'mask': __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default.a
  },

  data: function data() {
    return {
      sitekey: '6LdyLyIUAAAAAPjoJrn4oVRblZ1WBX5yTSPB36uL',
      isLoading: false,
      isReseting: false,
      mascaraTelefone: '(99) 9999-9999',
      form: {
        recaptcha: '',
        nome: '',
        email: '',
        telefone: '',
        opcoes: ['Empresa de serviços', 'Empresa de comércio', 'Outro tipo'],
        selecionadas: [],
        valid: false
      },
      rules: {
        nome: [{ required: true, message: 'O nome é obrigatório', trigger: 'blur' }],
        email: [{ required: true, message: 'O email é obrigatório', trigger: 'blur' }, { type: 'email', message: 'Você deve digitar um email válido', trigger: 'blur' }],
        telefone: [{ required: true, pattern: /\((10)|([1-9][1-9])\) [0-9]{4,5}-[0-9]{4}/, message: 'Você deve digitar um telefone no formato correto (Fixo ou Celular): Ex. (99) 9999-9999 ou (99) 99999-9999', trigger: 'blur' }],
        selecionadas: [{ type: 'array', required: true, message: 'Você deve selecionar uma das opções', trigger: 'blur' }]
      },
      mostraFormulario: false
    };
  },


  computed: {
    isValid: function isValid() {
      return this.form.valid;
    }
  },

  watch: {
    form: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          if (!_this.isReseting) {
            _this.verifyValidation();
          } else {
            _this.isReseting = false;
          }
        });
      },

      deep: true
    }
  },

  methods: {
    atualizaMascara: function atualizaMascara(ev) {
      if (ev.target.value.indexOf(') 9') !== -1) {
        this.mascaraTelefone = '(99) 99999-9999';
      } else {
        this.mascaraTelefone = '(99) 9999-9999';
      }
    },
    onSubmit: function onSubmit() {
      this.$refs.recaptcha.execute();
    },
    verifyRecaptcha: function verifyRecaptcha(recaptcha) {
      this.form.recaptcha = recaptcha;

      this.sendForm();
    },
    recaptchaExpired: function recaptchaExpired() {
      this.$message({ type: 'error', message: 'A verificação expirou, por favor, faça novamente.' });

      this.form.recaptcha = '';
    },
    verifyValidation: function verifyValidation() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        _this2.form.valid = valid;

        return valid;
      });
    },
    sendForm: function sendForm() {
      var _this3 = this;

      this.isLoading = true;

      setTimeout(function () {
        if (_this3.isValid) {
          _this3.$http.post('https://api.alternativacont.com.br/abrir-empresa', _this3.form).then(function (response) {
            _this3.$swal({
              animation: 'slide-from-top',
              title: 'Enviado com sucesso!',
              text: 'Aguarde nosso contato',
              type: 'success',
              timer: 5000,
              showConfirmButton: false
            }).catch(_this3.$swal.noop);

            _this3.$nextTick(function () {
              _this3.backToBeginSetup();
            });
          }).catch(function (response) {

            _this3.$swal({
              animation: 'slide-from-top',
              title: 'Houve um erro',
              html: 'Por favor tente novamente mais tarde ou entre em contato.',
              type: 'error',
              showConfirmButton: false
            }).catch(_this3.$swal.noop);

            _this3.$nextTick(function () {
              _this3.backToBeginSetup();
            });
          });
        }
      }, 5000);
    },
    backToBeginSetup: function backToBeginSetup() {
      this.isReseting = true;
      this.$refs.recaptcha.reset();
      this.$refs.form.resetFields();
      this.isLoading = false;
      this.mostraFormulario = false;
    }
  }
});

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_awesome_mask__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha___default.a
  },

  directives: {
    'mask': __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default.a
  },

  data: function data() {
    return {
      sitekey: '6LdyLyIUAAAAAPjoJrn4oVRblZ1WBX5yTSPB36uL',
      isLoading: false,
      isReseting: false,
      mascaraTelefone: '(99) 9999-9999',
      form: {
        recaptcha: '',
        nome: '',
        email: '',
        telefone: '',
        opcoes: ['Tenho empresa de serviços', 'Tenho empresa de comércio', 'Quero abrir empresa de serviços'],
        selecionadas: [],
        valid: false
      },
      rules: {
        nome: [{ required: true, message: 'O nome é obrigatório', trigger: 'blur' }],
        email: [{ required: true, message: 'O email é obrigatório', trigger: 'blur' }, { type: 'email', message: 'Você deve digitar um email válido', trigger: 'blur' }],
        telefone: [{ required: true, pattern: /\((10)|([1-9][1-9])\) [0-9]{4,5}-[0-9]{4}/, message: 'Você deve digitar um telefone no formato correto (Fixo ou Celular): Ex. (99) 9999-9999 ou (99) 99999-9999', trigger: 'blur' }],
        selecionadas: [{ type: 'array', required: true, message: 'Você deve selecionar uma das opções', trigger: 'blur' }]
      },
      mostraFormulario: false
    };
  },


  computed: {
    isValid: function isValid() {
      return this.form.valid;
    }
  },

  watch: {
    form: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          if (!_this.isReseting) {
            _this.verifyValidation();
          } else {
            _this.isReseting = false;
          }
        });
      },

      deep: true
    }
  },

  methods: {
    atualizaMascara: function atualizaMascara(ev) {
      if (ev.target.value.indexOf(') 9') !== -1) {
        this.mascaraTelefone = '(99) 99999-9999';
      } else {
        this.mascaraTelefone = '(99) 9999-9999';
      }
    },
    onSubmit: function onSubmit() {
      this.$refs.recaptcha.execute();
    },
    verifyRecaptcha: function verifyRecaptcha(recaptcha) {
      this.form.recaptcha = recaptcha;

      this.sendForm();
    },
    recaptchaExpired: function recaptchaExpired() {
      this.$message({ type: 'error', message: 'A verificação expirou, por favor, faça novamente.' });

      this.form.recaptcha = '';
    },
    verifyValidation: function verifyValidation() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        _this2.form.valid = valid;

        return valid;
      });
    },
    sendForm: function sendForm() {
      var _this3 = this;

      this.isLoading = true;

      setTimeout(function () {
        if (_this3.isValid) {
          _this3.$http.post('https://api.alternativacont.com.br/contabilidade-online', _this3.form).then(function (response) {
            _this3.$swal({
              animation: 'slide-from-top',
              title: 'Enviado com sucesso!',
              text: 'Aguarde nosso contato',
              type: 'success',
              timer: 5000,
              showConfirmButton: false
            }).catch(_this3.$swal.noop);

            _this3.$nextTick(function () {
              _this3.backToBeginSetup();
            });
          }).catch(function (response) {

            _this3.$swal({
              animation: 'slide-from-top',
              title: 'Houve um erro',
              html: 'Por favor tente novamente mais tarde ou entre em contato.',
              type: 'error',
              showConfirmButton: false
            }).catch(_this3.$swal.noop);

            _this3.$nextTick(function () {
              _this3.backToBeginSetup();
            });
          });
        }
      }, 5000);
    },
    backToBeginSetup: function backToBeginSetup() {
      this.isReseting = true;
      this.$refs.recaptcha.reset();
      this.$refs.form.resetFields();
      this.isLoading = false;
      this.mostraFormulario = false;
    }
  }
});

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_awesome_mask__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha___default.a
  },

  directives: {
    'mask': __WEBPACK_IMPORTED_MODULE_1_awesome_mask___default.a
  },

  data: function data() {
    return {
      sitekey: '6LdyLyIUAAAAAPjoJrn4oVRblZ1WBX5yTSPB36uL',
      isLoading: false,
      isReseting: false,
      mascaraTelefone: '(99) 9999-9999',
      form: {
        recaptcha: '',
        nome: '',
        email: '',
        telefone: '',
        opcoes: ['Empresa de serviços', 'Empresa de comércio', 'Outro tipo'],
        selecionadas: [],
        valid: false
      },
      rules: {
        nome: [{ required: true, message: 'O nome é obrigatório', trigger: 'blur' }],
        email: [{ required: true, message: 'O email é obrigatório', trigger: 'blur' }, { type: 'email', message: 'Você deve digitar um email válido', trigger: 'blur' }],
        telefone: [{ required: true, pattern: /\((10)|([1-9][1-9])\) [0-9]{4,5}-[0-9]{4}/, message: 'Você deve digitar um telefone no formato correto (Fixo ou Celular): Ex. (99) 9999-9999 ou (99) 99999-9999', trigger: 'blur' }],
        selecionadas: [{ type: 'array', required: true, message: 'Você deve selecionar uma das opções', trigger: 'blur' }]
      },
      mostraFormulario: false
    };
  },


  computed: {
    isValid: function isValid() {
      return this.form.valid;
    }
  },

  watch: {
    form: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          if (!_this.isReseting) {
            _this.verifyValidation();
          } else {
            _this.isReseting = false;
          }
        });
      },

      deep: true
    }
  },

  methods: {
    atualizaMascara: function atualizaMascara(ev) {
      if (ev.target.value.indexOf(') 9') !== -1) {
        this.mascaraTelefone = '(99) 99999-9999';
      } else {
        this.mascaraTelefone = '(99) 9999-9999';
      }
    },
    onSubmit: function onSubmit() {
      console.log(this.$refs.recaptcha);
      this.$refs.recaptcha.execute();
    },
    verifyRecaptcha: function verifyRecaptcha(recaptcha) {
      console.log('here');
      this.form.recaptcha = recaptcha;

      this.sendForm();
    },
    recaptchaExpired: function recaptchaExpired() {
      this.$message({ type: 'error', message: 'A verificação expirou, por favor, faça novamente.' });

      this.form.recaptcha = '';
    },
    verifyValidation: function verifyValidation() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        _this2.form.valid = valid;

        return valid;
      });
    },
    sendForm: function sendForm() {
      var _this3 = this;

      this.isLoading = true;

      console.log(this.isValid);

      console.log('oi');

      setTimeout(function () {
        if (_this3.isValid) {
          _this3.$http.post('https://api.alternativacont.com.br/mei-para-me', _this3.form).then(function (response) {
            _this3.$swal({
              animation: 'slide-from-top',
              title: 'Enviado com sucesso!',
              text: 'Aguarde nosso contato',
              type: 'success',
              timer: 5000,
              showConfirmButton: false
            }).catch(_this3.$swal.noop);

            _this3.$nextTick(function () {
              _this3.backToBeginSetup();
            });
          }).catch(function (response) {

            _this3.$swal({
              animation: 'slide-from-top',
              title: 'Houve um erro',
              html: 'Por favor tente novamente mais tarde ou entre em contato.',
              type: 'error',
              showConfirmButton: false
            }).catch(_this3.$swal.noop);

            _this3.$nextTick(function () {
              _this3.backToBeginSetup();
            });
          });
        }
      }, 2000);
    },
    backToBeginSetup: function backToBeginSetup() {
      this.isReseting = true;
      this.$refs.recaptcha.reset();
      this.$refs.form.resetFields();
      this.isLoading = false;
      this.mostraFormulario = false;
    }
  }
});

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "size": "medium",
      "top": "5%",
      "show-close": false
    },
    model: {
      value: (_vm.mostraFormulario),
      callback: function($$v) {
        _vm.mostraFormulario = $$v
      },
      expression: "mostraFormulario"
    }
  }, [_c('el-row', [_c('h1', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_vm._v("Quer abrir Empresa?")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('h3', [_vm._v("Somos especialistas em abrir empresas de serviços")]), _vm._v(" "), _c('h4', [_vm._v("Somos um Escritório de Contabilidade Online que abre sua empresa de serviços e faz sua contabilidade de um jeito simples, moderno e online.")]), _vm._v(" "), _c('h5', [_vm._v("Conte com a orientação e o trabalho de especialistas para começar certo!")]), _vm._v(" "), _c('h4', [_vm._v("Preencha agora mesmo o formulário e receba uma cotação de nossos serviços.")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    key: "form",
    attrs: {
      "element-loading-text": "Enviando os dados, aguarde..."
    }
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Seu nome (Obrigatório)",
      "prop": "nome"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.nome),
      callback: function($$v) {
        _vm.form.nome = $$v
      },
      expression: "form.nome"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email (Obrigatório)",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Telefone com DDD (Somente números)",
      "prop": "telefone"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.telefone),
      expression: "form.telefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.mascaraTelefone),
      expression: "mascaraTelefone"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "Fixo ou Celular"
    },
    domProps: {
      "value": (_vm.form.telefone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.form.telefone = $event.target.value
      }, _vm.atualizaMascara]
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "selecionadas"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Qual tipo de empresa você quer abrir (Obrigatório)\"")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.form.selecionadas),
      callback: function($$v) {
        _vm.form.selecionadas = $$v
      },
      expression: "form.selecionadas"
    }
  }, _vm._l((_vm.form.opcoes), function(opcao) {
    return _c('el-checkbox', {
      key: opcao,
      staticStyle: {
        "font-weight": "normal"
      },
      attrs: {
        "label": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }))], 1), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.sitekey,
      "badge": "inline",
      "size": "invisible"
    },
    on: {
      "verify": _vm.verifyRecaptcha,
      "expired": _vm.recaptchaExpired
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.isValid,
      "type": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Enviar")])], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.mostraFormulario = true
      }
    }
  }, [_vm._v("Quero Abrir Empresa")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "size": "medium",
      "top": "5%",
      "show-close": false
    },
    model: {
      value: (_vm.mostraFormulario),
      callback: function($$v) {
        _vm.mostraFormulario = $$v
      },
      expression: "mostraFormulario"
    }
  }, [_c('el-row', [_c('h1', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_vm._v("Contabilidade Online especializada em empresas de serviços")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('h3', [_vm._v("Confira as vantagens de fazer a contabilidade da sua empresa com a Alternativa")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Serviço contábil com todas as atividades obrigatórias e geração de guias de pagamento de impostos;")]), _vm._v(" "), _c('li', [_vm._v("Atendimento de alta qualidade feito por contadores dedicados por chat, telefone, entre outros canais;")]), _vm._v(" "), _c('li', [_vm._v("Plataforma online de gerenciamento contábil e financeiro incluída na mensalidade com conciliação bancária, fluxo de caixa e muito mais;")]), _vm._v(" "), _c('li', [_vm._v("Economia de tempo e dinheiro e maior transparência na gestão dos processos contábeis e financeiros da sua empresa.")])]), _vm._v(" "), _c('h4', [_vm._v("Preencha o formulário e receba uma cotação agora mesmo")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    key: "form",
    attrs: {
      "element-loading-text": "Enviando os dados, aguarde..."
    }
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Seu nome (Obrigatório)",
      "prop": "nome"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.nome),
      callback: function($$v) {
        _vm.form.nome = $$v
      },
      expression: "form.nome"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email (Obrigatório)",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Telefone com DDD (Somente números)",
      "prop": "telefone"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.telefone),
      expression: "form.telefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.mascaraTelefone),
      expression: "mascaraTelefone"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "Fixo ou Celular"
    },
    domProps: {
      "value": (_vm.form.telefone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.form.telefone = $event.target.value
      }, _vm.atualizaMascara]
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "selecionadas"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Marque uma opção abaixo (Obrigatório)\"")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.form.selecionadas),
      callback: function($$v) {
        _vm.form.selecionadas = $$v
      },
      expression: "form.selecionadas"
    }
  }, _vm._l((_vm.form.opcoes), function(opcao) {
    return _c('el-checkbox', {
      key: opcao,
      staticStyle: {
        "font-weight": "normal"
      },
      attrs: {
        "label": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }))], 1), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.sitekey,
      "badge": "inline",
      "size": "invisible"
    },
    on: {
      "verify": _vm.verifyRecaptcha,
      "expired": _vm.recaptchaExpired
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.isValid,
      "type": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Enviar")])], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.mostraFormulario = true
      }
    }
  }, [_vm._v("Migrar Contabilidade")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "size": "medium",
      "top": "5%",
      "show-close": false
    },
    model: {
      value: (_vm.mostraFormulario),
      callback: function($$v) {
        _vm.mostraFormulario = $$v
      },
      expression: "mostraFormulario"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_vm._v("Quer transformar sua MEI em ME?")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('h3', [_vm._v("Somos um Escritório de Contabilidade Online que migra sua MEI para ME e faz sua contabilidade de um jeito simples, moderno e online.")]), _vm._v(" "), _c('h4', [_vm._v("Conte com a orientação e o trabalho de especialistas para começar certo!")]), _vm._v(" "), _c('h5', [_vm._v("Preencha agora mesmo o formulário e receba uma cotação de nossos serviços")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    key: "form",
    attrs: {
      "element-loading-text": "Enviando os dados, aguarde..."
    }
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Seu nome (Obrigatório)",
      "prop": "nome"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.nome),
      callback: function($$v) {
        _vm.form.nome = $$v
      },
      expression: "form.nome"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email (Obrigatório)",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Telefone com DDD (Somente números)",
      "prop": "telefone"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.telefone),
      expression: "form.telefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.mascaraTelefone),
      expression: "mascaraTelefone"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "Fixo ou Celular"
    },
    domProps: {
      "value": (_vm.form.telefone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.form.telefone = $event.target.value
      }, _vm.atualizaMascara]
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "selecionadas"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Qual tipo de empresa você quer migrar para ME (Obrigatório)\"")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.form.selecionadas),
      callback: function($$v) {
        _vm.form.selecionadas = $$v
      },
      expression: "form.selecionadas"
    }
  }, _vm._l((_vm.form.opcoes), function(opcao) {
    return _c('el-checkbox', {
      key: opcao,
      staticStyle: {
        "font-weight": "normal"
      },
      attrs: {
        "label": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }))], 1), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.sitekey,
      "badge": "inline",
      "size": "invisible"
    },
    on: {
      "verify": _vm.verifyRecaptcha,
      "expired": _vm.recaptchaExpired
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.isValid,
      "type": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Enviar")])], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.mostraFormulario = true
      }
    }
  }, [_vm._v("Migrar MEI para ME")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[58]);


// WEBPACK FOOTER //
// static/js/app.js